import { BaseNotificationContextEnum } from './base-notification-context.enum';

/**
 * Rental agreement notification context enum
 * @description Notification contexts specific to rental agreement subjects
 */
export enum RentalAgreementNotificationContextEnum {
	// Base contexts
	INSERTED = BaseNotificationContextEnum.INSERTED,
	UPDATED = BaseNotificationContextEnum.UPDATED,
	DELETED = BaseNotificationContextEnum.DELETED,

	// Rental agreement-specific contexts
	COMPLETED = 'completed',
	CANCELLED = 'cancelled',
	PENDING = 'pending',
	IN_PROGRESS = 'in_progress',
}
